import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "../components/sections/PageHero";
import Process from "../components/sections/Process";
import ProjectShowcase from "../components/sections/ProjectShowcase";
import CTASection from "../components/sections/CTASection";
import ContactForm from "../components/sections/ContactForm";
import { PAINTING_TYPES } from "../data/content";

export default function Painting() {
  return (
    <>
      <PageHero
        eyebrow="Service 03 · Painting"
        title="Professional Painting"
        italic="Services."
        subtitle="Interior, exterior, residential, commercial, industrial, texture, wood and metal painting — with proper wall preparation before final application."
        image="https://images.pexels.com/photos/6474504/pexels-photo-6474504.jpeg?auto=compress&cs=tinysrgb&w=2000"
      />

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
            <div className="md:col-span-7">
              <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
                Painting Services
              </div>
              <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
                A clean finish comes from{" "}
                <span className="font-serif-italic font-normal text-ink-mid">
                  clean preparation.
                </span>
              </h2>
            </div>
            <p className="md:col-span-5 self-end text-ink-muted leading-relaxed">
              Cracks, patches, dampness, dust, and old flaking paint all show
              through the final coat. Surface preparation — cleaning, crack
              repair, putty, primer — is treated as a real part of the job,
              not an afterthought.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink-line border border-ink-line">
            {PAINTING_TYPES.map((p, i) => (
              <article
                key={p.name}
                data-testid={`painting-type-${i}`}
                className="bg-white p-6 md:p-8 group hover:bg-ink hover:text-white transition-colors"
              >
                <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink-muted group-hover:text-white/50 mb-4">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-display text-xl md:text-2xl leading-tight">
                  {p.name}
                </h3>
                <p className="mt-3 text-sm text-ink-mid group-hover:text-white/70 leading-relaxed">
                  {p.note}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Process />
      <ProjectShowcase limit={8} />

      {/* Lead form */}
      <section className="py-16 md:py-24 bg-white border-t border-ink-line">
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <ContactForm
            defaultService="Painting"
            leadType="quote"
            source="painting_page"
            heading="Get Painting Quote"
            subheading="Tell us the property type, approximate area and what you want painted (interior, exterior, or both)."
          />
        </div>
      </section>

      <CTASection />

      <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-10 flex flex-wrap gap-4 justify-between text-sm text-ink-muted">
        <Link to="/epoxy-flooring" className="inline-flex items-center gap-2 hover:text-ink group">
          Also: Epoxy Flooring <ArrowUpRight size={14} className="group-hover:rotate-45 transition-transform" />
        </Link>
        <Link to="/waterproofing" className="inline-flex items-center gap-2 hover:text-ink group">
          Also: Waterproofing <ArrowUpRight size={14} className="group-hover:rotate-45 transition-transform" />
        </Link>
      </div>
    </>
  );
}
